import { createFileRoute } from "@tanstack/react-router";
import { createHashHistory, type History, type Listener } from "history";
import { useMemo } from "react";
import { Studio } from "sanity";

import config from "../../sanity.config";

export const Route = createFileRoute("/admin")({
  component: RouteComponent,
  ssr: false,
});

function createHashHistoryForStudio(): History {
  const history = createHashHistory();

  return {
    get action() {
      return history.action;
    },
    get location() {
      return history.location;
    },
    get createHref() {
      return history.createHref.bind(history);
    },
    get push() {
      return history.push.bind(history);
    },
    get replace() {
      return history.replace.bind(history);
    },
    get go() {
      return history.go.bind(history);
    },
    get back() {
      return history.back.bind(history);
    },
    get forward() {
      return history.forward.bind(history);
    },
    get block() {
      return history.block.bind(history);
    },
    // Overriding listen to workaround a problem where native history provides history.listen(location => void), but the npm package is history.listen(({action, location}) => void)
    listen(listener: Listener) {
      return history.listen(({ location }) => {
        // @ts-expect-error -- working around a bug? in studio
        listener(location);
      });
    },
  };
}

function RouteComponent() {
  const history = useMemo(() => createHashHistoryForStudio(), []);

  return (
    <div className="h-screen bg-slate-app instrument-sans text-slate-normal flex flex-col">
      <Studio config={config} unstable_history={history} />
    </div>
  );
}
